import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { ManualMeta } from "models/manual"

export interface ManualsSliceState {
  manuals: ManualMeta[]
  isLoaded: boolean
}

export const initialState: ManualsSliceState = {
  manuals: [],
  isLoaded: false,
}

const manualsSlice = createSlice({
  name: "manuals",
  initialState,
  reducers: {
    setManuals(state, { payload }: PayloadAction<ManualMeta[]>) {
      state.manuals = payload
      state.isLoaded = true
    },
  },
})

export const { setManuals } = manualsSlice.actions

export default manualsSlice.reducer
